import { getLocaleCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';

import { newInitiativesUrl, oms_url } from '../../../config/AppConfig';

export function allocationLinkRedirect(crn: string): void {
  globalThis.location.href =`${oms_url}/${getLocaleCookie()}/track-order?crn=${crn}`;
}

export function courierTrackingLinkRedirect(crn: string): void {
  globalThis.location.href =`${newInitiativesUrl}track-courier-order?source=website&crn=${crn}`;
}
